import { render, staticRenderFns } from "./hotmart-card-policies.vue?vue&type=template&id=1005cdab"
import script from "./hotmart-card-policies.vue?vue&type=script&lang=js"
export * from "./hotmart-card-policies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotInternal: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Internal/Internal.vue').default})
